import { getBatchPhotoCounts, getUploadIds } from "./uploads";
import { isEditableCheck } from "./isEditableCheck";

/**
 * enhanceBatches
 * @param {Object} props
 * @returns {Array} enhancedBatches
 */
export const enhanceBatches = async props => {
    try {
        const { batches, showOnlySuspendedCreators, batchesPerPage } = props;

        let enhancedBatches = [];
        const batchIds = batches.map(b => b.id);

        // Batch Photo Counts
        const currentPhotoCounts = await getBatchPhotoCounts(
            batchIds,
            showOnlySuspendedCreators
        );

        // get batch upload ids from batchIds
        const allBatchesUploadIds = await getUploadIds(batchIds);

        await Promise.all(
            batches.map(async (batch, idx) => {
                const paginationItemNumber = idx + 1;
                const page = Math.ceil(paginationItemNumber / batchesPerPage); // reverse lookup, what page am I on?

                let enhancedBatch = enhanceBatch({
                    ...props,
                    batch,
                    batchPhotoCounts: currentPhotoCounts,
                    paginationItemNumber,
                    allBatchesUploadIds,
                    page
                });

                // Add to batches
                enhancedBatches.push(enhancedBatch);
            })
        );

        return enhancedBatches;
    } catch (error) {
        const errorMessage = `enhanceBatches: Error: ${error}`;
        console.error(errorMessage);
        throw new Error(error);
    }
};

/**
 * enhanceBatch: Adding Props necessary for client-side needs
 * @param {Object} props
 * @returns Enhanced Batch
 */
export const enhanceBatch = ({
    batch,
    batchPhotoCounts,
    paginationItemNumber,
    allBatchesUploadIds,
    page,
    currentQueue,
    currentUser
}) => {
    try {
        return {
            ...batch,
            page: page,
            paginationItemNumber,
            photoCounts: batchPhotoCounts.find(bpc => bpc.id === batch.id),
            selectedUploadIds: batch.selectedUploadIds || [],
            uploadIds: getBatchUploadIds(allBatchesUploadIds, batch.id),
            photoShoot: enhancePhotoShoot(batch.photoShoot),
            isEditable: isEditableCheck({ batch, currentQueue, currentUser }),
            isFaded: false,
            isCollapsed: false,
            transitionRemoveStatus: "idle"
        };
    } catch (error) {
        const errorMessage = `enhanceBatch: Error: ${error}`;
        console.error(errorMessage, { batch, allBatchesUploadIds });
        throw error;
    }
};

/**
 * getBatchUploadIds
 * @param {Array} allBatchesUploadIds
 * @param {Number} batchId
 * @returns {Array} batchUploadIds
 */
const getBatchUploadIds = (allBatchesUploadIds, batchId) => {
    try {
        const batchUploadIds = allBatchesUploadIds.find(
            abuObj => abuObj.id === batchId
        );

        return batchUploadIds?.uploadIds || [];
    } catch (error) {
        const errorMessage = `getBatchUploadIds: Error: ${error}`;
        console.error(errorMessage, { batchId, allBatchesUploadIds });
        throw error;
    }
};

/**
 * getBatchUploadIds
 * @param {Object} photoShoot
 * @returns {Object} enahcnedPhotoShoot
 */
const enhancePhotoShoot = photoShoot => {
    try {
        if (!photoShoot) {
            return null;
        }

        return {
            ...photoShoot,
            errorMessage: ""
        };
    } catch (error) {
        const errorMessage = `enhancePhotoShoot: Error: ${error}`;
        console.error(errorMessage, { photoShoot });
        throw error;
    }
};
